import { StratumService } from "@cof/stratum";
import { OneTagPluginFactory } from "@cof/stratum/plugin/one-tag";
import { NewRelicPlusPluginFactory } from "@cof/stratum/plugin/new-relic-plus";
import {
  PRODUCT_NAME,
  TAG_CATALOG,
  CATALOG_VERSION,
} from "@cof/tag-catalog-featureddealer-mfe";
import { version } from "../../package.json";

const OneTagPlugin = OneTagPluginFactory();
const NewRelicPlusPlugin = NewRelicPlusPluginFactory();

export const stratumService = new StratumService({
  productName: PRODUCT_NAME,
  productVersion: version,
  catalog: {
    items: TAG_CATALOG,
    catalogVersion: CATALOG_VERSION,
  },
  plugins: [OneTagPlugin, NewRelicPlusPlugin],
});

export const setDealerContext = (dealerId: string): void => {
  OneTagPlugin.setContext("dealerId", dealerId);
};

export const setAlternateCustomerIdContext = (userId: string): void => {
  OneTagPlugin.setContext("alternateCustomerId", userId);
};
